import React from 'react'
import Dashboard from '../Components/Dashboard'
import MainGrid from './Components/MainGrid'

function PatientPage() {
  return (
    <MainGrid />
  )
}

export default PatientPage